/* CLEVO motion: story sequences, the How it works progress line, Up close markers,
   header state, offer feedback and the demo video. IntersectionObserver only: no scroll listeners. */
(function () {
  'use strict';

  var d = document, root = d.documentElement;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var design = !!(window.Shopify && window.Shopify.designMode);
  var hasIO = 'IntersectionObserver' in window;
  var motion = hasIO && !reduce && !design;
  if (motion) root.classList.add('mo');

  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function once(els, opts, fn) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); fn(en.target); } });
    }, opts);
    els.forEach(function (el) { io.observe(el); });
  }

  /* Sequenced blocks: [data-seq] gets .in the first time it is properly in view */
  function initSeq(scope) {
    var els = $$('[data-seq]', scope);
    if (!motion) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    once(els, { threshold: 0, rootMargin: '0px 0px -18% 0px' }, function (el) { el.classList.add('in'); });
  }

  /* How it works: steps light up in order and the line runs from one to the next */
  function initHow(scope) {
    $$('[data-how]', scope).forEach(function (list) {
      var steps = $$('.how-step', list);
      if (!steps.length) return;
      if (!motion) {
        steps.forEach(function (s, i) { s.classList.add('is-active'); if (i < steps.length - 1) s.classList.add('is-linked'); });
        return;
      }
      var next = 0, target = -1, running = false;
      function activate(i, now) {
        if (i > 0) steps[i - 1].classList.add('is-linked');
        setTimeout(function () { steps[i].classList.add('is-active'); }, i > 0 && !now ? 320 : 0);
      }
      function run() {
        if (next > target) { running = false; return; }
        running = true;
        // a step the visitor has already scrolled well into opens at once, so nothing sits blank
        var now = steps[next].getBoundingClientRect().top < window.innerHeight * 0.3;
        activate(next++, now);
        setTimeout(run, now ? 80 : 480);
      }
      once(steps, { threshold: 0, rootMargin: window.innerWidth < 860 ? '0px 0px -8% 0px' : '0px 0px -12% 0px' }, function (s) {
        target = Math.max(target, steps.indexOf(s));
        if (!running) run();
      });
    });
  }

  /* Up close: hovering a card lights its marker on the photo; markers pulse once on arrival */
  function initUpclose(scope) {
    $$('[data-upclose]', scope).forEach(function (stage) {
      $$('.upc-card', stage).forEach(function (card) {
        var n = card.getAttribute('data-callout');
        card.addEventListener('mouseenter', function () { stage.setAttribute('data-active', n); });
        card.addEventListener('mouseleave', function () { stage.removeAttribute('data-active'); });
      });
      if (!motion) return;
      var rings = $$('.upc-ring', stage);
      once([stage], { threshold: 0, rootMargin: '0px 0px -40% 0px' }, function () {
        rings.forEach(function (r, i) { setTimeout(function () { r.classList.add('is-pulse'); }, 650 + i * 280); });
      });
    });
  }

  /* Header: firmer background after scrolling; nav link follows the section in view */
  function initNav() {
    var bar = d.querySelector('[data-sticky-top]');
    if (!hasIO) return;
    if (bar && !d.querySelector('[data-scroll-sentinel]')) {
      var s = d.createElement('div');
      s.setAttribute('data-scroll-sentinel', '');
      s.setAttribute('aria-hidden', 'true');
      s.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:12px;pointer-events:none;visibility:hidden';
      d.body.insertBefore(s, d.body.firstChild);
      new IntersectionObserver(function (e) { bar.classList.toggle('is-scrolled', !e[0].isIntersecting); }).observe(s);
    }
    var links = $$('#navLinks a[href*="#"]:not(.btn)');
    var byId = {};
    links.forEach(function (a) {
      var id = (a.getAttribute('href') || '').split('#')[1];
      if (id && d.getElementById(id)) byId[id] = a;
    });
    var ids = Object.keys(byId);
    if (!ids.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        links.forEach(function (a) {
          var on = a === byId[en.target.id];
          a.classList.toggle('is-active', on);
          if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    ids.forEach(function (id) { io.observe(d.getElementById(id)); });
  }

  /* Offer: the chosen card, total, saving and button all confirm the change */
  function replay(el, cls) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  }
  function initOffer(scope) {
    if (reduce) return;
    $$('[data-offer-root]', scope).forEach(function (box) {
      var form = box.querySelector('[data-offer-form]');
      if (!form || form.hasAttribute('data-motion')) return;
      form.setAttribute('data-motion', '');
      form.addEventListener('change', function (e) {
        if (e.target.name !== 'id') return;
        replay(e.target.closest('.opt'), 'just-selected');
        replay(box.querySelector('[data-sum-total]'), 'roll');
        var save = box.querySelector('[data-sum-save-row]');
        if (save && !save.hidden) replay(save, 'flash');
        replay(box.querySelector('[data-add-btn]'), 'tick');
        replay(box.querySelector('.offer-visual .stage'), 'nudge');
      });
    });
  }

  /* Demo video: muted inline loop that only plays while on screen; paused for reduced motion */
  function initVideo(scope) {
    $$('[data-demo-video] video', scope).forEach(function (v) {
      v.muted = true;
      v.playsInline = true;
      if (reduce) {
        v.removeAttribute('autoplay');
        v.pause();
        v.controls = true;
        return;
      }
      if (!hasIO) return;
      new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      }, { threshold: 0.2 }).observe(v);
    });
  }

  function init() {
    initSeq();
    initHow();
    initUpclose();
    initNav();
    initOffer();
    initVideo();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();

  d.addEventListener('shopify:section:load', function (e) {
    initSeq(e.target);
    initHow(e.target);
    initUpclose(e.target);
    initOffer(e.target);
    initVideo(e.target);
  });
})();
